import { fetchAPI } from '@/shared/lib/api/client';
import type { CurrencyCode } from '@/shared/lib/currency';

import { JettonPaginatedHistory, JettonRound, JettonRoundDetail } from '../model/types';

export const jettonApi = {
  async placeBet(
    amount: number,
    currency: CurrencyCode,
    autoCashoutMultiplier?: number,
  ): Promise<JettonRound> {
    const { data } = await fetchAPI.post<JettonRound>('/jetton/bet', {
      amount,
      currency,
      autoCashoutMultiplier: autoCashoutMultiplier ?? null,
    });
    return data;
  },

  async cashout(): Promise<{ cashoutMultiplier: number; payout: number; currency: CurrencyCode }> {
    const { data } = await fetchAPI.post<{ cashoutMultiplier: number; payout: number; currency: CurrencyCode }>(
      '/jetton/cashout',
    );
    return data;
  },

  async cancelBet(): Promise<JettonRound> {
    const { data } = await fetchAPI.post<JettonRound>('/jetton/cancel-bet');
    return data;
  },

  async getCurrentRound(): Promise<JettonRound> {
    const { data } = await fetchAPI.get<JettonRound>('/jetton/current');
    return data;
  },

  async getHistory(page = 1, pageSize = 20): Promise<JettonPaginatedHistory> {
    const { data } = await fetchAPI.get<JettonPaginatedHistory>('/jetton/history', {
      params: { page, page_size: pageSize },
    });
    return data;
  },

  async getRoundDetail(roundId: string): Promise<JettonRoundDetail> {
    const { data } = await fetchAPI.get<JettonRoundDetail>(`/jetton/round/${roundId}`);
    return data;
  },
};
